<div class="node-container">
  <ul [class]="{ 'nested': !isNodeOpened(node) }">
    <li *ngFor="let node of node.children">
      <ng-container *ngIf="!node.deleted">
        <div class="node-header">
          <i class="material-icons" *ngIf="isPdf(node)">picture_as_pdf</i>
          <i class="material-icons" *ngIf="isImage(node)">image</i>
          <span [class]="{ 'caret': node.isDirectory, 'caret-down': isNodeOpened(node) }" (click)="openNode(node)">{{node.name}}</span>
          <span class="over-size clickeable" *ngIf="node.isDirectory" (click)="agregarFileODirectorio(node)">+</span>
          <i (click)="editNode(node)" class="material-icons clickeable">edit</i>
          <i (click)="deleteNode(node)" class="material-icons clickeable">delete</i>
        </div>
        <app-node [node]="node" (selectedChildren)="childSelectedChildren($event)"></app-node>
      </ng-container>
    </li>
  </ul>
</div>